import { useNotificationContext } from 'contexts/NotificationContext';

export default function useNotify() {
  const { notify } = useNotificationContext();
  return notify;
}
